function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="none" viewBox="0 0 64 64">
      <path
        fill="#0044F0"
        d="M50.157 24.056c-1.204 0-2.8-.027-4.785-.027-4.843 0-8.824-4.008-8.824-8.896V6.557c0-.674-.539-1.224-1.207-1.224H21.236c-6.583 0-11.903 5.403-11.903 12.024v28.734c0 6.946 5.574 12.576 12.452 12.576H42.79c6.559 0 11.876-5.368 11.876-11.995V25.256c0-.677-.536-1.224-1.206-1.221-1.128.008-2.48.021-3.303.021"
        opacity="0.4"
      ></path>
      <path
        fill="#0044F0"
        d="M42.89 6.846c-.797-.83-2.189-.258-2.189.89v7.033c0 2.95 2.43 5.376 5.379 5.376 1.858.021 4.44.027 6.632.021 1.122-.003 1.693-1.344.914-2.154-2.813-2.926-7.85-8.168-10.735-11.166"
        opacity="0.4"
      ></path>
      <path
        fill="#0044F0"
        fillRule="evenodd"
        d="M23.93 30.367h9.027a1.986 1.986 0 1 0 0-3.97H23.93a1.986 1.986 0 0 0 0 3.97m0 13.318h14.518a1.986 1.986 0 1 0 0-3.97H23.93a1.986 1.986 0 0 0 0 3.97"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default Icon;
